
import React from 'react';
import DOMPurify from 'dompurify';

interface RichTextRendererProps {
  content: string;
  className?: string;
}

export const RichTextRenderer: React.FC<RichTextRendererProps> = ({ 
  content,
  className = "prose prose-lg max-w-none" 
}) => {
  // Skip rendering if no content
  if (!content) return null;
  
  // Sanitize HTML content to prevent XSS attacks
  const sanitizedContent = DOMPurify.sanitize(content, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target'],
    FORCE_BODY: false
  });
  
  // Process iframe content to add responsive containers
  const processedContent = sanitizedContent.replace(
    /<iframe\s+([^>]*src="https?:\/\/(?:www\.)?(?:youtube\.com|player\.vimeo\.com)[^"]*"[^>]*)><\/iframe>/g,
    '<div class="video-container"><iframe $1></iframe></div>'
  );
  
  return (
    <div 
      className={className}
      dangerouslySetInnerHTML={{ __html: processedContent }}
    />
  );
};
